import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import classNames from 'classnames';

import s from './LeftSide.scss';
import { Container } from '../../../../../symphony';
import { MinimizeIcon } from '../../../../../shared/public/assets/icons/MinimizeIcon';
import { SlEventsService } from '../../../services/Business/sl-events.service';
import { lePlaygroundContext } from '../../../global-constants';

export interface IHeaderLeftSideProps {
	isDarkMode?: boolean;
}

export const HeaderLeftSide: React.FC<IHeaderLeftSideProps> = React.memo(
	({
		isDarkMode,
	}) => {
		useStyles(s);
		const eventService = Container.take(lePlaygroundContext.value, SlEventsService);

		return (
			<div className="sl-playground-left">
				<MinimizeIcon
					onClick={eventService.onTIYMinimizeClick}
					className={classNames('sl-playground-left__minimize-icon', {
						dark: !isDarkMode,
					})}
				/>
			</div>
		);
	},
);
